import { cn } from "@/lib/utils";
import { buildWeekStrip } from "@/lib/calendar/mobile-agenda";
import type { CalendarEvent } from "@/components/calendar/views/CalendarEventTypes";

type Props = {
  selected: Date;
  grouped: Map<string, CalendarEvent[]>;
  onSelectDay: (date: Date) => void;
};

export function MobileWeekView({ selected, grouped, onSelectDay }: Props) {
  const strip = buildWeekStrip(selected, grouped);
  return (
    <div className="grid grid-cols-7 gap-1.5 rounded-2xl border border-border/60 bg-card p-1.5 shadow-sm">
      {strip.map((d, i) => (
        <button
          key={i}
          type="button"
          aria-pressed={d.selected}
          onClick={() => onSelectDay(d.date)}
          className={cn(
            "relative flex min-h-[64px] min-w-0 flex-col items-center justify-center gap-1 rounded-xl border px-1.5 py-2 transition-colors",
            d.selected
              ? "border-primary bg-primary text-primary-foreground shadow-sm"
              : "border-transparent bg-background text-foreground active:bg-accent",
          )}
        >
          <span className="text-[10px] font-bold uppercase opacity-70">{d.weekdayLabel}</span>
          <span className="text-[20px] font-extrabold leading-none tabular-nums">{d.day}</span>
          {d.hasEvents ? (
            <span
              className={cn(
                "mt-0.5 min-w-4 rounded-full px-1 text-center text-[9px] font-bold leading-4 tabular-nums",
                d.selected ? "bg-primary-foreground text-primary" : "bg-primary/10 text-primary",
              )}
            >
              {d.eventCount}
            </span>
          ) : (
            <span className="mt-0.5 h-4" aria-hidden />
          )}
        </button>
      ))}
    </div>
  );
}
